import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    yRight,
    partMobilityIndicators,
    popupInformation,
    defaultBarPercentage,
    defaultCategoryPercentage,
    defaultDatalabelsProperties,
    defaultTicksCustomValue,
} from "../../../utils";

import settings from "../../../../settings.js";

const NbHabitants = {
    checked: false,
    titleSideBar: "Mobility Indicators Content.indicators.NbHabitants",
    titleIndicator: "Mobility Indicators Content.indicators.NbHabitants",
    popupInformation: {
        status: "false",
        text: popupInformation[partMobilityIndicators]["nbHabitants"],
    },
    keyFigure: {
        typeUpdate: "year", // year or geographical_area
        label: "Mobility Indicators Content.charts.NbHabitants.keyFigure.habitants",
        url:
            api_url +
            "charts/data/?part=mobility-indicators&type_label=cusco_years&indicator=nb_habitants&trend=projection&chart=nb_habitants&chart_data=False&indicator_key_figure=True&schema_city=",
        separator: "thousand",
        position: "",
    },
    charts: [
        {
            typeChart: "picto",
            typeLabels: "geographical_areas", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "geographical_area", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "false",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: true,
            indexAxis: "x", // x or y
            heightChart: "250",
            widthChart: "600",
            scales: {
                x: {
                    type: "category",
                    display: true,
                    stacked: false,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                y: {
                    type: "linear",
                    display: true,
                    stacked: false,
                    titleDisplay: true,
                    titleText: "",
                    gridDisplay: true,
                    beginAtZero: true,
                    max: null,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                yRight: yRight,
            },
            annotationsProperties: {
                annotation1: undefined,
                annotation2: undefined,
            },
            keyFigure: {
                typeUpdate: "year", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },
            datasets: settings.config.citiesDetails.map((city) => {
                let label =
                    "Mobility Indicators Content.charts.NbHabitants.legend.Provincia de " +
                    city.label +
                    " : REPLACEPICTOKEYFIGURE habitantes, REPLACESECONDPICTOKEYFIGURE% del área metropolitana";
                let url =
                    api_url +
                    `charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=nb_habitants&trend=projection&chart=nb_habitants_${city.id}` +
                    "&schema_city=";
                let cssClassIcon =
                    "dashboard-picto-human-teamwork-50px filter-" + city.id;
                return {
                    type: "picto-simple",
                    label: label,
                    data: [],
                    url: url,
                    backgroundColor:
                        configChartsColorPalettes["0"].backgroundColor,
                    borderColor: configChartsColorPalettes["0"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                    pictoProperties: {
                        cssClassIcon: cssClassIcon,
                    },
                };
            }),
        },
    ],
};

export default NbHabitants;
